import type { ColumnSpec } from '../types';

export const COLS: ColumnSpec[] = [
  { id: 'account',      label: 'Account name',        w: 200, type: 'text', frozen: true, align: 'left', primary: true },
  { id: 'template',     label: 'Engagement template', w: 180, type: 'text', frozen: true, align: 'left' },
  { id: 'affiliate',    label: 'Affiliate',           w: 160, type: 'text', frozen: true, align: 'left', frozenLast: true },
  { id: 'coachee',      label: 'Coachee',             w: 150, type: 'text', align: 'left' },
  { id: 'status',       label: 'Status',              w: 110, type: 'pill', align: 'center' },
  { id: 'sentStatus',   label: 'Sent',                w: 130, type: 'pill', align: 'center' },
  { id: 'sowStart',     label: 'SOW start',           w: 110, type: 'date', align: 'center' },
  { id: 'sowEnd',       label: 'SOW end',             w: 110, type: 'date', align: 'center' },
  { id: 'hBudget',      label: 'Hrs budget',          w: 100, type: 'num',  align: 'right' },
  { id: 'hIncurred',    label: 'Hrs incurred',        w: 110, type: 'num',  align: 'right', overBar: true },
  { id: 'oppNum',       label: 'NS opp #',            w: 90,  type: 'id',   align: 'right' },
  { id: 'milestone',    label: 'Milestone',           w: 230, type: 'text', align: 'left' },
  { id: 'dateInc',      label: 'Date incurred',       w: 110, type: 'date', align: 'center' },
  // Col M (Created Date / Entry Date Into Platform) was collapsed to mirror
  // col L per Kristin's guidance — both surface Completed_Date__c. Hidden in
  // the SPA to avoid showing the same value twice; kept in the xlsx export
  // because Finance still expects 21 columns.
  { id: 'hours',        label: 'Hours',               w: 80,  type: 'num',  align: 'right' },
  { id: 'rate',         label: 'Affil. rate',         w: 110, type: 'cur',  align: 'right' },
  { id: 'feeBudget',    label: 'Client fee budget',   w: 150, type: 'cur',  align: 'right' },
  { id: 'clientFee',    label: 'Client hr fee',       w: 110, type: 'cur',  align: 'right' },
  { id: 'oppId',        label: 'NS opp ID',           w: 100, type: 'id',   align: 'right' },
  { id: 'projectId',    label: 'NS project ID',       w: 110, type: 'id',   align: 'right' },
  { id: 'engagementId', label: 'CC engagement',       w: 120, type: 'id',   align: 'right' },
  { id: 'sessionId',    label: 'CC session',          w: 110, type: 'id',   align: 'right' },
  // V–AG NetSuite-prep columns. The full set (memos, length, internal ID, %)
  // lives in the .xlsx export; the table surfaces the high-value financials.
  { id: 'cogs',         label: 'COGS',                w: 110, type: 'cur',  align: 'right' },
  { id: 'hoursRevenue', label: 'Hours revenue',       w: 120, type: 'cur',  align: 'right' },
  { id: 'vendorName',   label: 'Vendor (NetSuite)',   w: 200, type: 'text', align: 'left' },
  { id: 'coacheeLast',  label: 'Coachee last',        w: 130, type: 'text', align: 'left' },
  { id: 'expiration',   label: 'Expiration',          w: 110, type: 'date', align: 'center' },
];

export const STATUSES = ['Completed', 'Active', 'Cancelled'] as const;
